import React from 'react';
// import './Home.css';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';


const About = () => {
    return (
        <>
            <Header />
            <div> <p> Hello About</p></div>
            <Footer />
        </>

    )
}

export default About;